/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListWhatsAppConfig } from '../../models/api-response-list-whats-app-config';

export interface GetListWhatsAppConfigByCompanyId$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
}

export function getListWhatsAppConfigByCompanyId(http: HttpClient, rootUrl: string, params: GetListWhatsAppConfigByCompanyId$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListWhatsAppConfig>> {
  const rb = new RequestBuilder(rootUrl, getListWhatsAppConfigByCompanyId.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListWhatsAppConfig>;
    })
  );
}

getListWhatsAppConfigByCompanyId.PATH = '/v1/api/ui/company/config';
